import {createSlice} from "@reduxjs/toolkit";
import {RouteGroup} from "../../../model/route-group";
import {KeyObject} from "../../ots-store";
import {changeRegion} from "../region/actions";
import {routeGroupApi} from "./route-group-store";

export type RouteGroupState = {
  routeGroupRouteMap: {
    [key: string]: string[] | undefined;
  };
  routeRouteGroupMap: {
    [key: string]: string[] | undefined;
  };
}

const INITIAL_STATE: RouteGroupState = {
  routeGroupRouteMap: {},
  routeRouteGroupMap: {},
};

const routeGroupSlice = createSlice({
  name: 'routeGroups',
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(changeRegion, (_state) => {
      return INITIAL_STATE
    });
    builder.addMatcher(routeGroupApi.endpoints.getRouteGroup.matchFulfilled, (state, {payload}) => {
      state.routeGroupRouteMap[payload.id] = payload.routes?.map((r) => r.id) ?? [];
    });
    builder.addMatcher(routeGroupApi.endpoints.getAllRouteGroups.matchFulfilled, (state, {payload}) => {
      state.routeGroupRouteMap = getRouteGroupRouteMap(payload);
      state.routeRouteGroupMap = getRouteRouteGroupMap(payload);
    });
  },
});

const getRouteGroupRouteMap = (routeGroups: RouteGroup[]) => {
  const routeGroupRouteMap: KeyObject = {};

  routeGroups.forEach((group) => {
    routeGroupRouteMap[group.id] = group.routes?.map((r) => r.id) ?? [];
  });

  return routeGroupRouteMap;
};

const getRouteRouteGroupMap = (routeGroups: RouteGroup[]) => {
  const routeRouteGroupMap: KeyObject = {};

  routeGroups.forEach((group) => {
    group.routes?.forEach((r) => {
      if (!routeRouteGroupMap[r.id]) {
        routeRouteGroupMap[r.id] = [];
      }

      routeRouteGroupMap[r.id]?.push(group.id);
    });
  });

  return routeRouteGroupMap;
};

export const routeGroupReducer = routeGroupSlice.reducer;
